import LaunchIcon from './launch.png';

const iconSize = 16;

const encodeColour = (colour) => {
  return colour.replace('#', '%23');
};

const styles = (theme) => ({
  root: {
    boxSizing: 'border-box',
    width: '100%',
    paddingTop: theme.spacing.unit * 3,
    paddingRight: '24px',
    paddingLeft: '20px',
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing.unit,
      paddingLeft: theme.spacing.unit,
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '11px',
    },
    [theme.breakpoints.up('xl')]: {
      paddingRight: '0',
    },
    '&:focus': {
      outline: 'none',
    },
    // Following are styles that may be injected by SilverStripe in HTML fields.
    '& a.external': {
      '&::after': {
        content: "''",
        background: `url(
          '${LaunchIcon}'
        )`,
        width: iconSize,
        height: iconSize,
        backgroundSize: `${iconSize}px ${iconSize}px`,
        position: 'relative',
        top: -2,
        left: 0,
        display: 'inline-block',
      },
    },
    '& .nonvisual-indicator:not(:focus):not(:active)': {
      clip: 'rect(0 0 0 0)',
      clipPath: 'inset(100%)',
      height: 1,
      overflow: 'hidden',
      position: 'absolute',
      whiteSpace: 'nowrap',
      width: 1,
    },
    '& div > ul:last-child, & div > ol:last-child': {
      marginBottom: 0,
    },
  },
});

export default styles;
